
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"43","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M16 39a2 2 0 110 4 2 2 0 010-4zm0-39c8.837 0 16 7.135 16 15.935 0 6.627-4.06 12.308-9.839 14.712C17.231 33.097 16.615 38 16 38c-.615 0-1.23-4.903-6.117-7.335C4.081 28.272 0 22.579 0 15.935 0 7.135 7.163 0 16 0z","fill":"#FFE700"}}),_c('path',{attrs:{"d":"M15.842 1.81c-7.744 0-14.031 6.378-14.031 14.258 0 7.88 6.287 14.258 14.031 14.258 7.744 0 14.032-6.377 14.032-14.258 0-7.88-6.288-14.257-14.032-14.257z","fill":"#FFF"}})])])
          )
        }
      }
    